import { CardNumberElement } from '@stripe/react-stripe-js';
import { formatCountryAsTwoLetterCode } from 'packages/formatters';

export const createStripeToken = async (pii, elements, stripe) => {
  try {
    const card = elements.getElement(CardNumberElement);
    const tokenData = {
      name: pii.name,
      address_line1: pii.address,
      address_city: pii.city,
      address_country: formatCountryAsTwoLetterCode(pii.country),
      address_zip: pii.postalCode,
    };
    
    // Only include state if it exists (not required for UK)
    if (pii.state) {
      tokenData.address_state = pii.state;
    }
    
    const { error, token } = await stripe.createToken(card, tokenData);
    if (error) {
      return { error };
    }
    return { token };
  } catch (error) {
    return { error };
  }
};

export const createToken = async (pii, elements, stripe) => {
  try {
    const { error, token } = await createStripeToken(pii, elements, stripe);
    if (error) {
      return { error: error.message };
    }
    return { token };
  } catch (error) {
    return { error };
  }
};
